import { render, staticRenderFns } from "./ProjectBar.vue?vue&type=template&id=8881433a&scoped=true&"
import script from "./ProjectBar.vue?vue&type=script&lang=js&"
export * from "./ProjectBar.vue?vue&type=script&lang=js&"
import style0 from "./ProjectBar.vue?vue&type=style&index=0&id=8881433a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8881433a",
  null
  
)

export default component.exports